import { defineStore } from 'pinia';
import { actions, state, getters } from '@/stores/methods';


export const useCustomerChannelStore = defineStore('customerChannel', {
  state: state,
  actions: actions,
  getters: {
    getByIds: (state) => {
      return (objectIds) => state.collection.filter(c => objectIds.indexOf(c.id) !== -1);
    },
    ...getters,
  }
});
